import React, { useEffect, useState, useRef } from "react";
import "../css/ImageScrollGallery.css";
import { Button, Stack } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight, faImage } from "@fortawesome/free-solid-svg-icons";
import test1 from "../assets/iog.jpg";
import test2 from "../assets/jesm.png";
import test3 from "../assets/zpbr.png";
import Message from "./Message";

const ImageScrollGallery = () => {
  const [screenSize, setScreenSize] = useState("md");
  const [journals, setJournals] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [showArrows, setShowArrows] = useState(true);
  const [message, setMessage] = useState(null);
  const showMessage = (content) => {
    setMessage(content);
    setTimeout(() => setMessage(null), 2000); // 2秒后消失
  };
  const containerRef = useRef(null);

  // 屏幕尺寸检测
  useEffect(() => {
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const checkScreenSize = () => {
    const width = window.innerWidth;
    if (width < 576) setScreenSize("xs");
    else if (width < 768) setScreenSize("sm");
    else if (width < 992) setScreenSize("md");
    else if (width < 1200) setScreenSize("lg");
    else setScreenSize("xl");
  };

  // 每屏显示数量
  const visibleCount = screenSize === "xs" ? 2 : 5;

  // 使用图片数据替换静态期刊数据
  useEffect(() => {
    // 替换为test1、test2、test3图片的数组
    const staticJournals = [
      { id: "1", title: "Journal 1", img: test1 },  // 第一张图片
      { id: "2", title: "Journal 2", img: test2 },  // 第二张图片
      { id: "3", title: "Journal 3", img: test3 }   // 第三张图片
    ];
    
    const originalLength = staticJournals.length;
    
    // 数据处理逻辑保持不变
    let cloned;
    let startIdx = 0;
    
    if (originalLength <= visibleCount) {
      cloned = [...staticJournals];
      startIdx = 0;
    } else {
      const head = staticJournals.slice(0, visibleCount);
      const tail = staticJournals.slice(-visibleCount);
      cloned = [...tail, ...staticJournals, ...head];
      startIdx = visibleCount;
    }

    setJournals(cloned);
    setCurrentIndex(startIdx);
    setShowArrows(originalLength > visibleCount);
  }, [visibleCount]);

  // 上一张
  const handlePrev = () => {
    if (isTransitioning || !showArrows) return;
    setIsTransitioning(true);
    setCurrentIndex((prev) => Math.max(0, prev - 1));
  };

  // 下一张
  const handleNext = () => {
    if (isTransitioning || !showArrows) return;
    setIsTransitioning(true);
    setCurrentIndex((prev) => Math.min(journals.length - 1, prev + 1));
  };

  // 动画结束后瞬移
  const handleTransitionEnd = () => {
    setIsTransitioning(false);

    if (journals.length > visibleCount * 3) {
      if (currentIndex < visibleCount) {
        const realIndex = journals.length - visibleCount * 2;
        setCurrentIndex(realIndex);
        containerRef.current.style.transition = "none";
        containerRef.current.style.transform = `translateX(-${realIndex * (100 / visibleCount)}%)`;
        requestAnimationFrame(() => {
          containerRef.current.style.transition = "transform 0.5s ease";
        });
      } else if (currentIndex >= journals.length - visibleCount) {
        setCurrentIndex(visibleCount);
        containerRef.current.style.transition = "none";
        containerRef.current.style.transform = `translateX(-${visibleCount * (100 / visibleCount)}%)`;
        requestAnimationFrame(() => {
          containerRef.current.style.transition = "transform 0.5s ease";
        });
      }
    }
  };

  // 偏移计算
  const translateX = -(currentIndex * (100 / visibleCount));

  const renderJournalCard = (item, idx) => {
    const gradientDirections = [
      "at bottom right",
      "at top left",
      "at top right",
      "at bottom left",
    ];
    const direction = gradientDirections[idx % gradientDirections.length];
  
    return (
      <a
        className="journal"
        key={`${item.id || "card"}-${idx}`}
        // href={item.img ? `journal/${item.id}` : "#"}
        onClick={() => showMessage(`In Preparation`)}
        style={{
          textDecoration: "none",
          flex: `0 0 ${100 / visibleCount}%`,
          padding: "0 5px",
          boxSizing: "border-box",
        }}
      >
        <div className="article-card relative" style={{ paddingTop: "135%", overflow: "hidden" }}>
          <div style={{ position: "absolute", inset: 0 }}>
            {item.img ? (  // 显示图片（现在这三个项都会走这个分支）
              <img
                src={item.img}
                alt={item.title || item.id}
                className="w-100 h-100"
                style={{
                  objectFit: "cover",
                  borderRadius: "6px",
                }}
              />
            ) : item.isComingSoon ? (  // 原有的coming soon逻辑保留（当前三个项不会触发）
              <div
                className="d-flex justify-content-center align-items-center h-100 text-white"
                style={{
                  backgroundImage: `radial-gradient(${direction}, #000000 40%, #003366 100%)`,
                  borderRadius: "6px",
                  transition: "background-position 0.6s ease",
                }}
                onClick={() => showMessage(`In Preparation`)}
              >
                {item.title}
              </div>
            ) : (  // 无图片无coming soon的默认显示
              <div className="d-flex justify-content-center align-items-center h-100 border border-dashed">
                <FontAwesomeIcon icon={faImage} size="2x" />
              </div>
            )}
          </div>
        </div>
      </a>
    );
  };
  

  return (
    <div style={{ overflow: "hidden" }}>
    {message && <Message content={message} onClose={() => setMessage(null)} />}
      <div
        className="d-flex"
        ref={containerRef}
        style={{
          transform: `translateX(${translateX}%)`,
          transition: isTransitioning ? "transform 0.5s ease" : "none",
          padding:"10px 0"
        }}
        onTransitionEnd={handleTransitionEnd}
      >
        {journals.map((item, i) => renderJournalCard(item, i))}
      </div>

      {showArrows && (
        <Stack direction="horizontal" gap={3} className="justify-center mt-3 mb-4">
          <Button onClick={handlePrev}>
            <FontAwesomeIcon icon={faChevronLeft} />
          </Button>
          <div className="vr" />
          <Button onClick={handleNext}>
            <FontAwesomeIcon icon={faChevronRight} />
          </Button>
        </Stack>
      )}
    </div>
  );
};

export default ImageScrollGallery;